<template>
<div class="chapter">
<div class="inner_page">
      ﻿






<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>The Angel
Answer Book</title>
<p class="ser1" id="aa_4"><img alt="images/img-5-1.jpg" src="images/img-5-1.jpg"/></p>
<p class="ct" id="pAp7">
<a href="#/contents#bb_4"><span style="color:#007467;">Do angels really exist?</span></a> </p>
<p class="tx1" id="pAIV2">
<span class="dcap" style="color:#007467;">T</span>he Bible consistently affirms the existence of angels. They appear in its pages
naturally,
personally, and frequently. From Genesis to Revelation, the biblical writers weave
angels in and out, and the teachings about angels are consistent and cohesive, rational
and logical. </p>
<p class="tx" id="pA6x">
Angelology is a therapeutic subject for our souls. The Lord must have wanted us to
ponder the marvel of angels if He spoke of them so frequently. Colossians 3:2 tells
us to set our minds on things above, not on things of earth. The “things above” certainly
include the angelic world. Martin Luther said, “The acknowledgment of angels is needful
in the church. Therefore godly preachers should teach them logically. . . . They
should show what angels are. . . . They must speak touching their function. . . .
In this sort ought we to teach with care, method, and attention, touching the sweet
and loving angels.”<sup><span href="#/chapter112a#mm_ch4_2" id="nn_ch4_2" title="Link target outside of Sample">2</span></sup> </p>
<p class="tx" id="pAzI">
British historian Thomas B. Macaulay described the Puritans as people “whose minds
had derived a peculiar advantage from the daily contemplation of superior beings
and eternal interests.”<sup><span href="#/chapter112a#mm_ch4_3" id="nn_ch4_3" title="Link target outside of Sample">3</span></sup> </p>
<p class="ser2"><img alt="images/img-23-1.jpg" id="AyA" src="images/img-23-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter04.vue?6eb23484